// extracted by mini-css-extract-plugin
module.exports = {"s1a9pc87":"s1a9pc87","s9xyq6p":"s9xyq6p","s3c3uzm":"s3c3uzm"};